import type { EditorSDK } from '@wix/platform-editor-sdk';

import { APP_TOKEN, FORM_COMPONENT_TYPE, POPUP_COMPONENT_TYPE } from '../editor-app-module/constants';

async function pageHasChildType(
  editorSDK: EditorSDK,
  pageId: string,
  acceptedTypes: readonly string[],
): Promise<boolean> {
  try {
    const componentRef = await editorSDK.document.components.getById(APP_TOKEN, {
      id: pageId,
    });
    const children =
      (componentRef &&
        (await editorSDK.document.components.getChildren(APP_TOKEN, {
          componentRef,
        }))) ??
      [];
    for (const childRef of children) {
      const type = await editorSDK.document.components.getType(APP_TOKEN, {
        componentRef: childRef,
      });
      if (acceptedTypes.includes(type)) {
        return true;
      }
    }
    return false;
  } catch {
    return false;
  }
}

async function hasCustomSignupPage(editorSDK: EditorSDK): Promise<boolean> {
  const pageId = await editorSDK.siteMembers.getCustomSignupPageId(APP_TOKEN);
  return pageId ? pageHasChildType(editorSDK, pageId, [FORM_COMPONENT_TYPE, POPUP_COMPONENT_TYPE]) : false;
}

async function hasCustomLoginPage(editorSDK: EditorSDK): Promise<boolean> {
  const pageId = await editorSDK.siteMembers.getCustomSignInPageId(APP_TOKEN);
  return pageId ? pageHasChildType(editorSDK, pageId, [POPUP_COMPONENT_TYPE]) : false;
}

export async function hasCustomAuthPages(editorSDK: EditorSDK): Promise<boolean> {
  const [hasSignup, hasLogin] = await Promise.all([hasCustomSignupPage(editorSDK), hasCustomLoginPage(editorSDK)]);
  return hasSignup || hasLogin;
}

export async function hasRestrictedPages(editorSDK: EditorSDK): Promise<boolean> {
  const allPages = await editorSDK.document.pages.data.getAll(APP_TOKEN);
  return allPages.some((data: { pageSecurity?: { requireLogin?: boolean } }) => data.pageSecurity?.requireLogin);
}
